import React, { useState, useEffect } from 'react';

const DownloadReasonModal = ({ isOpen, onClose, onConfirm, isDownloading }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px';
      setReason('');
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason.trim()) {
      onConfirm(reason.trim());
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#000] bg-opacity-50 backdrop-blur-[10px] flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Download Contacts CSV
        </h3>
        <p className="text-gray-600 mb-4">
          Please provide a reason for downloading the contacts list.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Reason <span className="text-red-500">*</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for download (e.g., for campaign, analysis, etc.)"
              required
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              disabled={isDownloading}
            />
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isDownloading}
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isDownloading || !reason.trim()}
              className="px-4 py-2 bg-[#3985b6] text-white rounded-md hover:bg-[#2b6a94] disabled:opacity-50 flex items-center gap-2"
            >
              {isDownloading && (
                <div className="animate-spin h-4 w-4 border-t-2 border-white rounded-full"></div>
              )}
              {isDownloading ? 'Downloading...' : 'Download'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DownloadReasonModal;

